var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.biz)?_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Tax Rates")]),_c('v-spacer'),_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":function($event){return _vm.create()}}})],1),_c('Table')],1):_vm._e(),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }